<div id="printContent" style="color: #333;">
  <button class="tourPageBtn mr-3" id="help-tour-btn" (click)="startTour()" title="Take a tour">
    <img src="/assets/images/tutorialOverlayBttn.svg" />
  </button>
  <div class="header-controls split-flex">
    <h3><fa-icon [icon]="supportIcon"></fa-icon> Contact Support</h3>
  </div>
  <div class="report-section-header"></div>
  <div class="boxed-content">
    <div class="alert alert-secondary">
      <strong>Have a question or need some help?</strong> Tell us about what's going on and we will get back to you with a response
      as soon as we can!
    </div>
    @if (errorMessage()) {
      <div class="alert alert-danger">
        {{ errorMessage() }}
      </div>
    }
    @if (!submitted()) {
      <form (ngSubmit)="onSubmit()" #contactForm="ngForm">
        <div id="nameField" class="form-group">
          <label for="nameInput"><fa-icon [icon]="userIcon"></fa-icon> Your Name* </label>
          <input type="text" class="form-control" id="nameInput" name="name" [(ngModel)]="fullName" required>
        </div>
        <div id="topicField" class="form-group">
          <label for="topicInput"><fa-icon [icon]="topicIcon"></fa-icon> Topic*</label>
          <select class="form-control" id="topicInput" name="topic" [(ngModel)]="topic" required>
          @for (option of topicOptions; track option.value) {
            <option [value]="option.name" >{{option.name}}</option>
          }
            <option value="other">Other...</option>
          </select>

          @if (isOtherSelected()) {
            <input type="text" class="form-control mt-2" id="otherInput" name="otherTopic" [(ngModel)]="otherTopic" placeholder="Please specify">
          }
        </div>
        <div id="messageField" class="form-group">
          <label for="messageArea"><fa-icon [icon]="messageIcon"></fa-icon> What's Going On?*</label>
          <textarea class="form-control" id="supportMessage" rows="5" name="message" [(ngModel)]="message" required></textarea>
        </div>
        <div id="followUpField" class="form-group">
          <label style="margin-bottom: 12px;"><fa-icon [icon]="contactIcon"></fa-icon> How Should We Follow Up?*</label><br>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="contactPreference" id="emailRadio" value="email" [(ngModel)]="contactPreference" required>
            <label class="form-check-label" for="emailRadio">Email</label>
            <input type="email" class="form-control ml-2" id="emailInput" name="email" placeholder="Email" [(ngModel)]="email" [disabled]="contactPreference() !== 'email'" required>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="contactPreference" id="phoneRadio" value="phone" [(ngModel)]="contactPreference" required>
            <label class="form-check-label" for="phoneRadio">Phone</label>
            <input type="text" class="form-control ml-2" id="phoneInput" name="phone" placeholder="Phone number" [(ngModel)]="phone" [disabled]="contactPreference() !== 'phone'" required>
          </div>
        </div>
        <button id="sendButton" type="submit" class="btn action-button" [disabled]="contactForm.invalid">
          <fa-icon [icon]="sendIcon"></fa-icon> Send
        </button>
      </form>
    } @else {
      <div style="margin-top: 50px;">
        <h1>Submitted!</h1>
        <p>Thank you for contacting us! We will get back to you as soon as we can.</p>
      </div>
    }
  </div>
</div>
